import { WHERE } from 'src/utils/firebase/firebase-manager';
import { getProductInventories } from 'src/utils/firebase/firebase-short-cut';
import useSWRImmutable from 'swr/immutable';

const getProductInventories0 = (where: WHERE[]) => getProductInventories(where);

const useSWRProductInventories = (key: string | null, where: WHERE[] = []) => {
  const {
    data: productInventories,
    isLoading,
    mutate,
  } = useSWRImmutable(key ? `productInventories-${key}` : null, () => getProductInventories0(where));

  return {
    productInventories,
    isLoading,
    refresh: () => mutate(),
  };
};

export default useSWRProductInventories;
